import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {toDateString} from '../../providers/app-date-adapter';
import {FormControl} from '@angular/forms';
import {IdentStatus} from '../../dto/ident-status';
import {CompanyService} from '../services/company.service';
import {Company} from '../../dto/company';
import {InvoicesReportService} from '../services/invoices-report.service';
import {InvoiceListReport} from '../../dto/invoice-list-report';
import {FileHelper} from '../../helpers/file-helper';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-payment-report',
  templateUrl: './payment-report.component.html',
  styleUrls: ['./payment-report.component.css']
})
export class PaymentReportComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,

    public companiesService: CompanyService,
    public invoicesReportService: InvoicesReportService,
    private snackBar: MatSnackBar,

  ) { }



  public webIdStatusSelect = new FormControl();
  public companySelect = new FormControl();
  public companies: Company[];
  public webIdStatus = IdentStatus;

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.invoicesReportService);
  columns = [

    { columnDef: 'Nr', header: 'Nr', cell: (row: InvoiceListReport) => `${row.code}` },
    { columnDef: 'Token', header: 'Token', cell: (row: InvoiceListReport) => row.card.token },
    { columnDef: 'Name', header: 'Name', cell: (row: InvoiceListReport) => `${row.card.customer.title} ${row.card.customer.firstName} ${row.card.customer.lastName}` },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: InvoiceListReport) => `${toDateString(row.card.customer.dob)}` },
    { columnDef: 'Address', header: 'Address', cell: (row: InvoiceListReport) => `${row.card.customer.address}, ${row.card.customer.zipCode} ${row.card.customer.city}` },
    { columnDef: 'email', header: 'Email', cell: (row: InvoiceListReport) => `${row.card.customer.email}` },
    { columnDef: 'phone', header: 'Mobile', cell: (row: InvoiceListReport) => `${row.card.customer.phone}` },
    { columnDef: 'Partner', header: 'Partner', cell: (row: InvoiceListReport) => row.productCompanyName },

    { columnDef: 'collection', header: 'Coll', cell: (row: InvoiceListReport) => row.collectionBy },
    { columnDef: 'Bill', header: 'Bill', cell: (row: InvoiceListReport) => row.billAmount },
    { columnDef: 'Paid', header: 'Paid', cell: (row: InvoiceListReport) => row.paidAmount },
    { columnDef: 'Outstanding', header: 'Outst.', cell: (row: InvoiceListReport) => row.outstandingAmount },
    { columnDef: 'firstReminder', header: 'First reminder', cell: (row: InvoiceListReport) => row.firstReminder == null ? '' : `${toDateString(row.firstReminder.date)}` },
    { columnDef: 'markedAsPaidDate', header: 'Marked as paid', cell: (row: InvoiceListReport) => row.markedAsPaidDate == null ? '' : `${toDateString(row.markedAsPaidDate)}` },

  ];

  public dateFiltersList = [
    { name: 'creationDate', header: 'Creation date' },
    { name: 'firstReminder', header: 'First reminder' },
    { name: 'markedAsPaidDate', header: 'Marked as paid' }
  ];

  ngOnInit() {
    this.companiesService.getAll().subscribe( x => {
      this.companies = x.data;
    });

    this.table.filters.additionalField1 = 'amount_lower_than_or_equal';
    this.table.filters.additionalField2 = 'amount_greater_than_or_equal';
  }


  downloadAttachment() {


    this.invoicesReportService.getReportCsv(
      0,
      99999999,
      this.table.filters.sortField,
      this.table.filters.sortDirection,
      this.table.filters.str,
      this.table.filters.dateFilterCols,
      this.table.filters.startFilterDate,
      this.table.filters.endFilterDate,
      this.table.filters.someAdditionalData,
      this.table.filters.additionalFilterData,
      this.table.filters.enumFilter,
      this.table.filters.companiesFilter,
      this.table.filters.additionalField1,
      this.table.filters.additionalField2,
      this.table.filters.additionalValue1,
      this.table.filters.additionalValue2
      ) .subscribe(
      result => {
        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }


  onCompanyChange() {
    this.table.filters.someAdditionalData = 'companyid_' + this.companySelect.value; // TODO heavy abuse
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }



  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }



  clearFilter(){

    this.companySelect.patchValue(null);
    this.table.clearFilter();
  }

}
